/** Mirrors platform-api `PENDING_ENGAGEMENTS_FILTER_BY_FINDINGS` — tag rules apply to pending SQL when true. */
export function isPendingEngagementsFilterByFindingsEnabled(): boolean {
  const raw = process.env.PENDING_ENGAGEMENTS_FILTER_BY_FINDINGS;
  return raw === 'true';
}
